import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgPlus from '../../svg/plus.svg'
import { IconProps } from '../icon-props'

const PlusIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgPlus
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-plus', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default PlusIcon
